import MessageService from './MessageService';

const messageService = new MessageService();

export default messageService;
